const COPCO_SWATCH_SELECTOR = '[data-copco-swatch]';
const originalCardStates = new WeakMap();

function getProductCard(element) {
  return element?.closest('product-card') || null;
}

function getMainImage(card) {
  return (
    card.querySelector('.product-media__image') ||
    card.querySelector('.product-card__media-container img') ||
    card.querySelector('.product-card__image img') ||
    card.querySelector('.media img') ||
    card.querySelector('img')
  );
}

function rememberOriginalState(card) {
  const savedState = originalCardStates.get(card);
  if (savedState) return savedState;

  const image = getMainImage(card);
  const picture = image?.closest('picture');
  const sources = picture ? Array.from(picture.querySelectorAll('source')) : [];
  const link = card.querySelector('.product-card__link');

  const state = {
    image,
    imageSrc: image?.getAttribute('src') || '',
    imageSrcset: image?.getAttribute('srcset') || '',
    imageAlt: image?.getAttribute('alt') || '',
    sources: sources.map((source) => ({
      element: source,
      srcset: source.getAttribute('srcset') || '',
    })),
    link,
    linkHref: link?.getAttribute('href') || '',
    featuredMediaUrl: card.getAttribute('data-featured-media-url') || '',
  };

  originalCardStates.set(card, state);
  return state;
}

function setActiveSwatch(card, activeSwatch) {
  card.querySelectorAll(COPCO_SWATCH_SELECTOR).forEach((swatch) => {
    const isActive = swatch === activeSwatch;
    swatch.classList.toggle('is-active', isActive);
    swatch.setAttribute('aria-pressed', String(isActive));
  });
}

function updateCardFromSwatch(swatch) {
  const card = getProductCard(swatch);
  if (!card) return;

  const state = rememberOriginalState(card);
  const imageUrl = swatch.dataset.variantImg || '';
  const imageSrcset = swatch.dataset.variantSrcset?.trim() || imageUrl;
  const imageAlt = swatch.dataset.variantAlt || state.imageAlt;
  const variantUrl = swatch.dataset.variantUrl || '';

  if (state.image && imageUrl) {
    state.image.setAttribute('src', imageUrl);
    state.image.setAttribute('srcset', imageSrcset);

    if (imageAlt) {
      state.image.setAttribute('alt', imageAlt);
    }

    state.sources.forEach(({ element }) => {
      element.setAttribute('srcset', imageSrcset);
    });

    card.setAttribute('data-featured-media-url', imageUrl);
  }

  if (state.link && variantUrl) {
    state.link.setAttribute('href', variantUrl);
  }

  setActiveSwatch(card, swatch);
}

function restoreCard(card) {
  const state = originalCardStates.get(card);
  if (!state) return;

  if (state.image) {
    if (state.imageSrc) {
      state.image.setAttribute('src', state.imageSrc);
    }

    if (state.imageSrcset) {
      state.image.setAttribute('srcset', state.imageSrcset);
    } else {
      state.image.removeAttribute('srcset');
    }

    if (state.imageAlt) {
      state.image.setAttribute('alt', state.imageAlt);
    }
  }

  state.sources.forEach(({ element, srcset }) => {
    if (srcset) {
      element.setAttribute('srcset', srcset);
    } else {
      element.removeAttribute('srcset');
    }
  });

  if (state.link && state.linkHref) {
    state.link.setAttribute('href', state.linkHref);
  }

  if (state.featuredMediaUrl) {
    card.setAttribute('data-featured-media-url', state.featuredMediaUrl);
  } else {
    card.removeAttribute('data-featured-media-url');
  }

  card.querySelectorAll(COPCO_SWATCH_SELECTOR).forEach((swatch) => {
    swatch.classList.remove('is-active');
    swatch.setAttribute('aria-pressed', 'false');
  });
}

document.addEventListener('pointerover', (event) => {
  if (!(event.target instanceof Element)) return;

  const swatch = event.target.closest(COPCO_SWATCH_SELECTOR);
  if (!swatch) return;

  const previousElement = event.relatedTarget;
  if (previousElement instanceof Node && swatch.contains(previousElement)) return;

  updateCardFromSwatch(swatch);
});

document.addEventListener('focusin', (event) => {
  if (!(event.target instanceof Element)) return;

  const swatch = event.target.closest(COPCO_SWATCH_SELECTOR);
  if (swatch) updateCardFromSwatch(swatch);
});

/*
 * Capture phase prevents Horizon's product-card click handler from
 * treating a swatch click as a click on the whole product card.
 */
document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;

    const swatch = event.target.closest(COPCO_SWATCH_SELECTOR);
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();
    updateCardFromSwatch(swatch);
  },
  true
);

document.addEventListener('pointerout', (event) => {
  if (!(event.target instanceof Element)) return;

  const card = getProductCard(event.target);
  if (!card) return;

  const nextElement = event.relatedTarget;
  if (nextElement instanceof Node && card.contains(nextElement)) return;

  restoreCard(card);
});

document.addEventListener('focusout', (event) => {
  if (!(event.target instanceof Element)) return;

  const card = getProductCard(event.target);
  if (!card) return;

  requestAnimationFrame(() => {
    if (!card.contains(document.activeElement)) {
      restoreCard(card);
    }
  });
});
